import { AbstractModel } from '@/models/abstractModel';
import type { IWebSocketUserRow } from '@/types/webSocketUser';

export class WebSocketUserItem extends AbstractModel {
    public browser: string;
    public connectionId: number;
    public ip: string | null;
    public os: string;
    public pageUrl: string;
    public startAt: string;
    public uniqAppId: string;
    public updateUserDate: string | null;
    public userId: number;
    public userLogin: string;
    public userTimezone: string;
    public userTypeId: number;

    constructor(data: IWebSocketUserRow) {
        super();
        this.connectionId = data.connectionId;
        this.userId = data.user.id;
        this.userLogin = data.user.login;
        this.userTypeId = data.user.type_id;
        this.ip = data.user.last_login_from_ip ?? null;
        this.os = data.os;
        this.browser = data.browser;
        this.pageUrl = data.pageUrl ?? '';
        this.startAt = data.startAt;
        this.uniqAppId = data.uniqAppId;
        this.updateUserDate = data.updateUserDate ?? null;
        this.userTimezone = data.user.user_timezone ?? '';
    }

    public matchesSearch(query: string): boolean {
        const q = query.trim().toLowerCase();
        if (!q) return true;

        const fields = [
            String(this.connectionId),
            this.uniqAppId,
            this.userLogin,
            this.ip ?? '',
            this.os,
            this.browser,
            this.pageUrl,
            this.startAt,
            this.updateUserDate ?? '',
        ];

        return fields.some((field) => field.toLowerCase().includes(q));
    }
}
